import React from 'react';
import styles from "../styles/game-center-header.module.scss";
import classNames from "classnames";
import {BaseProps} from "../../../../../infrastructure/models/props/base-props";
import type {GameCenterHeaderModuleController} from "../game-center-header-module.controller";
import {observer} from "mobx-react";
import {Ellipsis} from "../../../../../core/components/misc/ellipsis/ellipsis";
import {Link} from "../../../../../core/components/link/link";

export class GameCenterHeaderModuleDescriptionProps extends BaseProps {
  controller: GameCenterHeaderModuleController;
}

export const GameCenterHeaderModuleDescription = observer(({controller}: GameCenterHeaderModuleDescriptionProps) => {
  const {state: {descriptionEntity, entityLinkModel, isGameRoute}} = controller;

  const titleProps = {
    model: entityLinkModel
  }

  const TitleTag = isGameRoute ? 'h1' : 'div';

  return (<div className={classNames(styles.header_description_container)}>
      {
        descriptionEntity ?
          <>
            <Link {...titleProps}><TitleTag className={classNames(styles.header_description_title)}>{descriptionEntity.title}</TitleTag></Link>
            <Ellipsis
              className={classNames(styles.header_description_description)}>{descriptionEntity.description}</Ellipsis>
          </> : null
      }
    </div>
  )
});
